import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomersService } from 'src/app/services/customer/customer.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user/user.service';
import { CustomerdosService } from 'src/app/services/customerdos/customerdos.service';
import { SettingService } from 'src/app/services/setting/setting.service';
import { PhleboService } from 'src/app/services/phlebo/phlebo.service';
import { OrderService } from 'src/app/services/order/order.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-view-phlebo-modal',
  templateUrl: './view-phlebo-modal.component.html',
  styleUrls: ['./view-phlebo-modal.component.scss']
})
export class ViewPhleboModalComponent implements OnInit {

    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();

    public title: string;
    public subTitle: any={};
    type: any;

    constructor(
        private ngbModal: NgbActiveModal,
        private toastr: ToastrService,
        private customerService: CustomersService,
        private userService: UserService,
        private customerdosService: CustomerdosService,
        private OrderService: OrderService,
        private settingService: SettingService,
        private phleboService: PhleboService,
        private router: Router,

    ) { }

    ngOnInit(): void {
        this.setDialogProps(this.props);

    }

    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.type = dialogdata.type;

        this.subTitle = dialogdata.subTitle;



    }



    onClose() {
        if(this.type=='CreateOrder')
        {
            this.router.navigateByUrl('/orders');

        }
        if(this.type=='PhleboList')
        {
        this.router.navigateByUrl('/phlebos/list');
        }
        if(this.type=='InvoiceUrl')
            {
            this.router.navigateByUrl('/orders');
            }

        this.ngbModal.close();
    }

}
